import styled from "@emotion/styled";

import BulletPoint from "./bullet-point.svg";

export const BulletPointWrapper = styled.div`
  display: flex;
`;

export const StyledBulletPoint = styled(BulletPoint)`
  margin-inline-end: 12px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-inline-end: 16px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-inline-end: 20px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    margin-inline-end: 24px;
  }
`;
